// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3OFBQ","label":"Section_label__3xUpS","contentWrap":"Section_contentWrap__pVQ1p","footer":"Section_footer___25v1","footerInner":"Section_footerInner__TSD3l"};